import * as service from './service'
import toast from '@flashex-fe-comp/issdesign/lib/toast'
export default {
  namespace: 'cashDetail',
  state: {
    detail: {}
  },
  effects: {
    * getCashDetail ({ payload }, { call, put }) {
      try {
        const res = yield call(service.getCashDetail, payload)
        const { data } = res
        if (data.status === 200) {
          yield put({
            type: 'save',
            payload: {
              detail: data.data
            }
          })
          return data.data
        } else {
          toast(data.err || '发生网络错误')
          return Promise.reject()
        }
      } catch (error) {
        toast('发生网络错误')
      }
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
